import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function containNgWordValidator(ngWords: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let isContain = false;
    const requestWord = control.value ? control.value as string : "";
    ngWords.forEach(ngWord => {
      if (requestWord.includes(ngWord)){;
      isContain = true;
      }
    });
    return isContain ? {"containNgWord": {value: control.value}} : null;
  }
}